import { TextField } from "@mui/material";
import React, { useState } from "react";
import { API } from "../../assets/staticData";
import SuccessAlert from "../success-alert/SuccessAlert";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
  "Content-Type": "application/json",
};

export default function AddCat({ refreshCats, setRefreshCats }) {
  const [openAddNew, setOpenAddNew] = useState(false);
  const [input, setInput] = useState("");
  const [show, setShow] = useState(false);

  const addNewCat = () => {
    if (input !== "") {
      fetch(`${API}/categories`, {
        headers,
        method: "POST",
        body: JSON.stringify({
          data: { category: input },
        }),
      }).then(() => {
        setInput("");
        setRefreshCats(!refreshCats);
        setOpenAddNew(false);
        setShow(true);
      });
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        onClick={() => setOpenAddNew(true)}
        style={{
          position: "relative",
          height: 25,
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        Add a new Category
      </div>
      <SuccessAlert
        show={show}
        setShow={setShow}
        message={"Added Successfully"}
      />

      <div
        className="sub-menu"
        style={{
          visibility: openAddNew ? "visible" : "hidden",
          opacity: openAddNew ? 1 : 0,
          height: openAddNew ? 240 : 0,
          width: 380,
          gap: 13,
          justifyContent: "center",
          left: -110,
          top: 30,
        }}
      >
        <TextField
          placeholder="New Category"
          sx={{ width: "85%" }}
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <div
          onClick={addNewCat}
          className="submitBTN"
          style={{ height: 38, width: "85%", borderRadius: 7, margin: 0 }}
        >
          Submit
        </div>
        <div
          style={{
            height: 32,
            width: "60%",
            marginTop: 2,
          }}
          className="cancelBTN"
          onClick={() => {
            setOpenAddNew(false);
          }}
        >
          Cancel
        </div>
      </div>
    </div>
  );
}
